// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sider[data-v-288c920c]{box-shadow:inset -1px 0 0 #f0f0f0;min-width:256px!important}", ""]);
// Exports
module.exports = exports;
